export default "__VITE_ASSET__BQiM4qLg__"